var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappCarousel1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 61,
    viewBox: "0 0 100 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2795 23.359L68.5571 35.4626C68.8604 36.3238 70.0065 36.6305 70.7611 36.0531L83.5339 26.2985C83.5339 26.2985 69.9606 21.3983 69.9606 21.6658C69.9606 21.9334 64.2795 23.359 64.2795 23.359Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9857 0.0982984C89.6422 3.15191 62.7143 13.36 52.5229 17.2259C51.1758 17.7381 51.257 19.5227 52.6428 19.9305L64.2801 23.3593L68.5435 35.4236C68.7163 35.9097 69.1465 36.2229 69.6297 36.3045C70.0211 36.373 70.5994 26.5336 70.5994 26.5336C70.5994 26.5336 82.8326 34.9278 88.6336 38.8883C90.0618 39.8638 92.1036 39.1297 92.4422 37.5181C94.1701 29.2773 98.4935 8.6719 99.9711 1.6251C100.197 0.571347 99.0683 -0.299715 97.9857 0.0982984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6327 36.308C70.0241 36.3765 70.6024 26.5371 70.6024 26.5371L90.6996 9.07346C90.8371 8.95601 90.6714 8.75701 90.5127 8.84509L64.2795 23.3595L68.543 35.4239C68.7158 35.91 69.1495 36.2232 69.6327 36.308Z",
    fill: "#B0BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.9996C13.8025 59.9605 32.1505 52.7604 35.8356 38.9343C37.3202 33.3556 36.0013 27.3756 31.2195 23.3041C25.1787 18.156 18.5455 22.8604 20.1782 30.041C22.8583 41.8411 38.4381 50.5778 50.2763 50.7018C57.1176 50.7736 63.5392 47.7363 66.0007 41.5344",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "5 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappCarousel1);
export default __webpack_public_path__ + "static/media/whatsapp-carousel-1.ad71c7bbc4a23d65c3684e1b3bd7622a.svg";
export { ForwardRef as ReactComponent };